export default "__VITE_ASSET__hr4hZ2AO__"